/* eslint-disable no-eval */
import generateApi from '../components/api/generateApi'
import alertUtils from './alertUtils'
import customApi from '../components/api/customApi'
import globalBus from '../util/globalBus'
/**
 * 生成表单工具
 */
export default class generateUtils {
  static isMobile() {
    const sUserAgent = navigator.userAgent
    let isMobile = false
    if (
      sUserAgent.indexOf('Android') > -1 ||
      sUserAgent.indexOf('iPhone') > -1 ||
      sUserAgent.indexOf('iPad') > -1 ||
      sUserAgent.indexOf('iPod') > -1 ||
      sUserAgent.indexOf('Symbian') > -1
    ) {
      isMobile = true
    }
    return isMobile
  }

  /**
   * 移动自适应处理
   * @param width
   * @param data
   */
  static adaptive(width, config, isMobile) {
    config.width = width
    if (isMobile || width <= 768) {
      if (
        !config.oldLabelPosition ||
        typeof config.oldLabelPosition === 'undefined'
      ) {
        config.oldLabelPosition = config.labelPosition
      }
      config.labelPosition = 'top'
    } else {
      if (
        config.oldLabelPosition &&
        typeof config.oldLabelPosition !== 'undefined'
      ) {
        config.labelPosition = config.oldLabelPosition
        config.oldLabelPosition = ''
      }
    }
  }

  /**
   * 刷新缓存数据
   * @param list
   */
  static flushCachedData(list) {
    if (list && list.length > 0) {
      list.forEach(obj => {
        if (obj.type === 'grid') {
          obj.columns.forEach(item => {
            this.flushCachedData(item.list)
          })
        } else if (obj.type === 'report') {
          // 表格布局组件
          obj.rows.forEach(cItem => {
            cItem.columns.forEach(columnItem => {
              this.flushCachedData(columnItem.list)
            })
          })
        } else if (obj.type === 'sonform') {
          this.flushCachedData(obj.list)
        } else if (
          Object.prototype.hasOwnProperty.call(
            obj.options,
            'remoteOptionsCache'
          )
        ) {
          // check 是否有 存储缓存字段
          this.getRemoteList(obj)
        }
      })
    }
  }

  /**
   * 清除缓存数据
   * @param list
   */
  static clearCachedData(list) {
    if (list && list.length > 0) {
      list.forEach(obj => {
        if (obj.type === 'grid') {
          obj.columns.forEach(item => {
            this.clearCachedData(item.list)
          })
        } else if (obj.type === 'report') {
          // 表格布局组件
          obj.rows.forEach(cItem => {
            cItem.columns.forEach(columnItem => {
              this.clearCachedData(columnItem.list)
            })
          })
        } else if (obj.type === 'sonform') {
          this.clearCachedData(obj.list)
        } else if (
          Object.prototype.hasOwnProperty.call(obj.options, 'remoteOptions')
        ) {
          // check 是否有 存储缓存字段  如果有，就清除该数据
          obj.options.remoteOptions = []
        }
      })
    }
  }

  /**
   * 初始化
   * @param widget
   */
  static initFormItem(widget) {
    if (
      Object.prototype.hasOwnProperty.call(widget.options, 'optionType') &&
      widget.options.optionType !== 'static'
    ) {
      this.getRemoteList(widget)
    }
    if (widget.type === 'date' && widget.options.disabledDate) {
      // 设置日期动态函数-以及禁用日期
      widget.options.pickerOptions = {
        // disabledDate() {
        //   //   const dateNum = time.getDate()
        //   //   const monthNum = time.getMonth() + 1
        //   //   const yearNum = time.getFullYear()
        //   //   const weekNum = time.getDay() === 0 ? 7 : time.getDay()
        //   return eval(widget.options.disabledDate)
        // },

        disabledDate: time => {
          const dateNum = time.getDate()
          const monthNum = time.getMonth() + 1
          const yearNum = time.getFullYear()
          const weekNum = time.getDay() === 0 ? 7 : time.getDay()
          return eval(
            widget.options.disabledDate,
            time,
            dateNum,
            monthNum,
            yearNum,
            weekNum
          )
        },
      }
    }
  }

  /**
   * 初始化
   * @param widget
   */
  static initSonFormItem(widget) {
    if (
      Object.prototype.hasOwnProperty.call(widget.options, 'optionType') &&
      widget.options.optionType !== 'static'
    ) {
      this.getRemoteList(widget)
    }
    if (widget.type === 'date' && widget.options.disabledDate) {
      // 设置日期动态函数-以及禁用日期
      widget.options.pickerOptions = {
        disabledDate() {
          //   const dateNum = time.getDate()
          //   const monthNum = time.getMonth() + 1
          //   const yearNum = time.getFullYear()
          //   const weekNum = time.getDay() === 0 ? 7 : time.getDay()
          return eval(widget.options.disabledDate)
        },
      }
    }
  }

  /**
   * 获取远程字典项列表 || 获取远端接口列表
   * @param widget
   */
  static getRemoteList(widget) {
    if (
      !Object.prototype.hasOwnProperty.call(widget.options, 'optionType') ||
      widget.options.optionType === 'static'
    ) {
      return
    }
    if (
      widget.options.remoteOptions &&
      widget.options.remoteOptions.length > 0 &&
      widget.options.remoteOptionsCache
    ) {
      // 使用缓存数据
      return
    }
    if (
      widget.options.optionType === 'dictionary' &&
      widget.options.dicTypeCode.code
    ) {
      // 系统字典
      this.getDicList(widget, widget.options.dicTypeCode.code)
    } else if (widget.options.optionType === 'service') {
      // 自定义接口
      this.queryRemoteService(widget)
    }
  }

  /**
   *  查询字典项目
   * @param widget
   * @param typeCode
   */
  static getDicList(widget, typeCode) {
    generateApi
      .getDicList(typeCode)
      .then(response => {
        if (
          widget.options.remoteOptions &&
          widget.options.remoteOptions.length > 0
        ) {
          // 使用缓存数据
          return
        }
        if (response.flag) {
          widget.options.remoteOptions = []
          if (response.data && response.data.length > 0) {
            response.data.forEach(function (item) {
              widget.options.remoteOptions.push({
                value: item.key_code,
                label: item.value_name,
              })
            })
          }
        }
      })
      .catch(() => {
        alertUtils.alertError(widget.name + '字典项列表查询错误', true)
      })
  }

  /**
   * 获取自定义接口项
   * @param widget
   */
  static queryRemoteService(widget) {
    if (widget && widget.options.remoteUrl) {
      if (widget.type === 'table') {
        return
      }
      // 增加query上的参数
      if (!widget.options.props.value && widget.type !== 'table') {
        alertUtils.alertError(widget.name + '接口返回结果值未设置', true)
      }
      if (!widget.options.props.label && widget.type !== 'table') {
        alertUtils.alertError(widget.name + '接口返回结果标题未设置', true)
      }
      if (
        widget.type === 'radio' ||
        widget.type === 'checkbox' ||
        widget.type === 'select' ||
        widget.type === 'cascader' ||
        widget.type === 'address' ||
        widget.type === 'organization'
      ) {
        customApi
          .requestInterface(widget.options.remoteUrl, null)
          .then(response => {
            widget.options.remoteOptions = []
            if (response) {
              const obj = eval(
                'response' +
                  (widget.options.props.paramFormat
                    ? '.' + widget.options.props.paramFormat
                    : '')
              )
              if (obj) {
                switch (widget.type) {
                  case 'table':
                    this.handleTableData(widget, obj)
                    break
                  default:
                    this.handleSelectOptions(widget, obj)
                }
              }
            }
          })
          .catch(e => {
            console.error(e)
            alertUtils.alertError(widget.name + '接口查询错误', true)
          })
      }
    }
  }

  /**
   * 获取远程分页表格数据
   * @param widget
   */
  static queryRemoteTableData(widget, queryParams) {
    if (widget && widget.options.remoteUrl) {
      customApi
        .requestInterface(widget.options.remoteUrl, queryParams)
        .then(response => {
          if (response) {
            const obj = eval(
              'response' +
                (widget.options.props.paramFormat
                  ? '.' + widget.options.props.paramFormat
                  : '')
            )
            this.handleTableData(widget, obj)
          }
        })
        .catch(() => {
          alertUtils.alertError(widget.name + '接口查询错误', true)
        })
    }
  }

  /**
   * 处理下拉框一类远程数据拼接
   * @param widget
   * @param obj
   */
  static handleSelectOptions(widget, obj) {
    if (widget.type === 'table') {
      widget.options.table.push({
        value: obj[widget.options.props.value],
        label: obj[widget.options.props.label],
      })
      return
    }
    obj.forEach(function (item) {
      widget.options.remoteOptions.push({
        value: item[widget.options.props.value],
        label: item[widget.options.props.label],
      })
    })
  }

  /**
   * 处理表格一类远程数据拼接
   * @param widget
   * @param obj
   */
  static handleTableData(widget, obj) {
    widget.options.tableTitle = obj[widget.options.props.tableTitle]
    widget.options.tableData = obj[widget.options.props.tableData]
    widget.options.total = obj[widget.options.props.total]
    widget.options.page = obj[widget.options.props.page]
    widget.options.pageSize = obj[widget.options.props.pageSize]
  }

  /**
   * 获取级联远程接口数据拼接
   * @param widget
   */
  static getCascaderOptions(widget, dataType) {
    if (!widget.options.props.pk) {
      alertUtils.alertError(widget.name + '接口返回结果主键未设置', true)
    }
    if (!widget.options.props.ppk) {
      alertUtils.alertError(widget.name + '接口返回结果父主键未设置', true)
    }
    if (!widget.options.props.value) {
      alertUtils.alertError(widget.name + '接口返回结果值未设置', true)
    }
    if (!widget.options.props.label) {
      alertUtils.alertError(widget.name + '接口返回结果标题未设置', true)
    }

    if (!widget.options.remoteUrl) {
      alertUtils.alertError(widget.name + '未设置接口地址', true)
      return
    }
    const params = {}
    if (widget.options.remoteQuery) {
      const remoteQuery = widget.options.remoteQuery
      const userInfo = JSON.parse(localStorage.getItem('currentUser'))
      if (remoteQuery.username) {
        params.username = userInfo.username
      }
      if (remoteQuery.fromWidget && remoteQuery.fromWidget.key) {
        params[remoteQuery.fromWidget.key] = remoteQuery.fromWidget.value
      } else if (
        widget.options.remoteOptions &&
        widget.options.remoteOptions.length > 0
      ) {
        return
      }
    }
    if (
      widget.type === 'organization' &&
      widget.options.orgRootId &&
      widget.options.remoteUrl === '/v1/process/getSubAllOrganizations'
    ) {
      params.id = widget.options.orgRootId
    }

    // if (
    //   widget.type === 'organization' &&
    //   widget.options.remoteUrl === '/v1/process/getPersonnelSelectionList'
    // ) {
    //   if (widget.options.groupId) {
    //     params.type = 'group'
    //     params.groupId = widget.options.groupId
    //   }
    //   if (widget.options.orgRootId) {
    //     params.type = 'org'
    //     params.orgId = widget.options.orgRootId
    //   }
    //   if (widget.options.groupId && widget.options.orgRootId) {
    //     params.type = 'orgAndGroup'
    //     params.orgId = widget.options.orgRootId
    //     params.groupId = widget.options.groupId
    //   }
    // }

    if (dataType === 'looking') {
      params.enable = -1
    }

    generateApi
      .getCustomService(widget.options.remoteUrl, params)
      .then(response => {
        if (response) {
          widget.options.remoteOptions = []
          this.handleOthersService(widget, response, widget.options.orgRootId)
        }
      })
      .catch(() => {
        alertUtils.alertError(widget.name + '接口查询错误', true)
      })
  }

  /**
   * 根据不同字段类型，指向不同处理结果
   * @param widget
   * @param obj
   */
  static handleCascaderResultType(widget, obj) {
    if (widget.type === 'organization') {
      // 组织机构
      this.handleOrganization(widget, obj)
    } else if (widget.type === 'address') {
      // 地区
      this.handleAddress(widget, obj)
    } else {
      // 自定义接口
      this.handleOthersService(widget, obj)
    }
  }

  /**
   *  组织机构处理
   * @param widget
   * @param obj
   */
  static handleOrganization(widget, obj) {
    if (obj.data) {
      const initMap = new Map()
      obj.data.forEach(function (item) {
        initMap.set(item.id, item)
      })
      for (const key of initMap.keys()) {
        if (initMap.get(key).pid === '' || initMap.get(key).pid.length === 0) {
          widget.options.remoteOptions.push(initMap.get(key))
        }
        if (initMap.get(initMap.get(key).pid)) {
          if (
            typeof initMap.get(initMap.get(key).pid).children === 'undefined'
          ) {
            initMap.get(initMap.get(key).pid).children = []
          }
          initMap.get(initMap.get(key).pid).children.push(initMap.get(key))
        }
      }
    }
  }

  /**
   *  地区处理
   * @param widget
   * @param obj
   */
  static handleAddress(widget, obj) {
    if (obj.data) {
      const initMap = new Map()
      obj.data.forEach(function (item) {
        initMap.set(item.id, item)
      })
      for (const key of initMap.keys()) {
        if (initMap.get(key).pid === '' || initMap.get(key).pid.length === 0) {
          widget.options.remoteOptions.push(initMap.get(key))
        }
        if (initMap.get(initMap.get(key).pid)) {
          if (
            typeof initMap.get(initMap.get(key).pid).children === 'undefined'
          ) {
            initMap.get(initMap.get(key).pid).children = []
          }
          initMap.get(initMap.get(key).pid).children.push(initMap.get(key))
        }
      }
    }
  }

  /**
   *  处理自定义接口
   * @param widget
   * @param obj
   */
  static handleOthersService(widget, obj, orgRootId) {
    const data = eval(
      'obj' +
        (widget.options.props.paramFormat
          ? '.' + widget.options.props.paramFormat
          : '')
    )
    const id = widget.options.props.pk
    const pid = widget.options.props.ppk
    const map = {}
    if (!data.length) {
      return
    }
    data.forEach(item => {
      if (orgRootId) {
        item.ins_name = item.name
        item.pid = item.parentId
        item.ins_code = item.code
      }
      map[item[id]] = item
    })
    // 初始化当前组织机构(需要可选任意层级)
    if (widget.type === 'organization' && widget.options.initCurOrgCode) {
      const curIdArr = []
      let curOrgItem = data.find(item => {
        return item.ins_code === widget.options.initCurOrgCode
      })
      if (curOrgItem) {
        curIdArr.push(curOrgItem.id)
        this.orgDeep(data, curOrgItem.id, curIdArr)
        globalBus.$emit('setData', {
          model: widget.model,
          value: curIdArr,
        })
      }
    }
    data.forEach(item => {
      const parent = map[item[pid]]
      if (parent) {
        ;(parent.children || (parent.children = [])).push(item)
      } else {
        widget.options.remoteOptions.push(item)
      }
    })
  }

  /**
   *  初始化当前组织机构-递归
   * @param data 机构列表平铺数据
   * @param orgId 当前机构code
   * @param orgIdArr 当前机构数组
   */
  static orgDeep(data, orgId, orgIdArr) {
    let target = data.find(item => {
      return orgId === item.id
    })
    if (target) {
      if (target.pid === '' || target.pid === null || target.pid === 'null') {
        return orgIdArr
      } else {
        // 查看terget父机构是否存在
        let tarParent = data.find(item => {
          return target.pid === item.id
        })
        // 若不存在，返回机构数组
        if (!tarParent) {
          return orgIdArr
        } else {
          // 若存在，继续向上找上一级
          orgIdArr.unshift(target.pid)
          return (orgIdArr = this.orgDeep(data, target.pid, orgIdArr))
        }
      }
    }
  }

  /**
   *  接口初始化单行，多行，文本，子表单数据
   * @param widget
   * @param dataList
   */

  static queryFormService(widget, dataList) {
    if (Object.prototype.hasOwnProperty.call(widget.options, 'initialValue')) {
      customApi
        .requestInterface(widget.options.remoteUrl, null)
        .then(response => {
          console.log('执行')
          if (response) {
            const obj = eval(
              'response' +
                (widget.options.props.paramFormat
                  ? '.' + widget.options.props.paramFormat
                  : '')
            )
            if (obj) {
              console.log('obj', obj)
              const newObj = {}
              newObj.id = widget.options.remoteUrl
              newObj.data = obj
              dataList.push(newObj)
            }
          }
          console.log('dataList', dataList)
        })
        .catch(e => {
          console.error(e)
          alertUtils.alertError(widget.name + '接口查询错误', true)
        })
    }
  }

  /**
   *  接口初始化单行，多行，文本，子表单数据
   * @param widget
   * @param obj
   */
  static handleFormDate(widget, obj) {
    if (
      Object.prototype.hasOwnProperty.call(widget.options, 'initialValue') &&
      widget.type !== 'sonform'
    ) {
      // 有自定义template的情况
      const labelName = widget.options.props.cascaderVal[0]
      if (widget.options.props.cascaderVal.length !== 1) {
        alertUtils.alertError(widget.name + ':请选择正确的标签', true)
      } else {
        if (typeof obj[labelName] === 'number') {
          globalBus.$emit('setData', {
            model: widget.model,
            value: String(obj[labelName]),
          })
        } else {
          globalBus.$emit('setData', {
            model: widget.model,
            value: obj[labelName],
          })
        }
      }
    } else if (
      Object.prototype.hasOwnProperty.call(widget.options, 'initialValue') &&
      widget.type === 'sonform'
    ) {
      const getSonFormData = []
      const sonDataName = widget.options.props.cascaderVal[0]
      console.log('sonDataName', sonDataName)
      if (!sonDataName) {
        alertUtils.alertError(widget.name + ':请选择标签', true)
      } else {
        if (obj[sonDataName] && Array.isArray(obj[sonDataName])) {
          obj[sonDataName].forEach(item => {
            const modelObj = {}
            for (let j = 0; j < widget.list.length; j++) {
              if (widget.list[j].options.props.cascaderVal.length === 1) {
                alertUtils.alertError(
                  '子表单内:(' + widget.list[j].name + ')请选择正确的标签',
                  true
                )
                break
              }
              if (widget.list[j].options.props.cascaderVal.length === 2) {
                const sonFormName = widget.list[j].options.props.cascaderVal[0]
                console.log('sonFormName', sonFormName)
                const labelName = widget.list[j].options.props.cascaderVal[1]
                if (sonDataName === sonFormName) {
                  // console.log("obj[sonDataName]",obj[sonDataName]);
                  if (typeof item[labelName] === 'number') {
                    modelObj[widget.list[j].model] = String(item[labelName])
                  } else {
                    modelObj[widget.list[j].model] = item[labelName]
                  }
                } else {
                  alertUtils.alertError('请选择正确的标签', true)
                  break
                }
              }
            }
            if (Object.keys(modelObj).length === 0) {
              return
            }
            getSonFormData.push(modelObj)
          })
          console.log('getSonFormData', getSonFormData)
          globalBus.$emit('resetSonFormData', {
            sonFormModel: widget.model,
            sonFormData: getSonFormData,
          })
        } else {
          alertUtils.alertError(widget.name + ':请选择正确的标签', true)
        }
      }
    }
  }

  /**
   *  接口初始化遍历组件接口-去除重复接口
   * @param list //表单组件列表
   * @param urlList //初始化的接口数据
   */
  static handleInitRemoteUrl(list, urlList) {
    list.forEach(item => {
      // 栅格布局组件
      if (item.type === 'grid') {
        item.columns.forEach(cItem => {
          this.handleInitRemoteUrl(cItem.list, urlList)
        })
      } else if (item.type === 'report') {
        // 表格布局组件
        item.rows.forEach(cItem => {
          cItem.columns.forEach(columnItem => {
            if (columnItem.list) {
              this.handleInitRemoteUrl(columnItem.list, urlList)
            }
          })
        })
      } else {
        // table（子表单）和非嵌套的符合初始化的组件
        if (
          Object.prototype.hasOwnProperty.call(item.options, 'initialValue') &&
          item.options.remoteUrl
        ) {
          urlList.push(item)
        }
      }
    })
  }

  /**
   *  接口初始化遍历嵌套组件
   * @param list //表单组件列表
   * @param queryDataList //初始化的接口数据
   */
  static handleInit(list, queryDataList) {
    list.forEach(item => {
      // 栅格布局组件
      if (item.type === 'grid') {
        item.columns.forEach(cItem => {
          this.handleInit(cItem.list, queryDataList)
        })
      } else if (item.type === 'report') {
        // 表格布局组件
        item.rows.forEach(cItem => {
          cItem.columns.forEach(columnItem => {
            this.handleInit(columnItem.list, queryDataList)
          })
        })
      } else {
        // table（子表单）和非嵌套的符合初始化的组件
        if (
          Object.prototype.hasOwnProperty.call(item.options, 'initialValue')
        ) {
          if (
            list.length === 1 &&
            item.type === 'sonform' &&
            !item.list.length
          ) {
            return
          }
          queryDataList.forEach(ele => {
            if (
              item.options.remoteUrl === ele.id &&
              !item.options.props.cascaderVal.length
            ) {
              alertUtils.alertWarning(item.name + ':请先选择标签', true)
            }
            if (
              item.options.remoteUrl === ele.id &&
              item.options.props.cascaderVal.length === 1
            ) {
              generateUtils.handleFormDate(item, ele.data)
            }
            if (
              item.options.remoteUrl === ele.id &&
              item.options.props.cascaderVal.length === 2
            ) {
              alertUtils.alertError(item.name + ':请选择正确的标签', true)
            }
          })
        }
      }
    })
  }

  /**
   *  单独获取组织机构列表
   * @param orglist
   */
  static justGetOrgData(orgListOptions) {
    const params = {}
    generateApi
      .getCustomService('/v1/institution/selectInsList', params)
      .then(response => {
        if (response) {
          response.data.forEach(item => {
            orgListOptions.push(item)
          })
        }
      })
      .catch(() => {
        alertUtils.alertError('组织机构列表' + '接口查询错误', true)
      })
  }
}
